module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Ukelele RO.6b5d376a.png";